module.exports = __webpack_public_path__ + "static/jeremiahs-2e3a88e2394d5d90c9d95bfa5f6ba289.png";